import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Store Edit"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-store-edit',
    templateUrl: './icon-store-edit.component.html',
    styleUrls: ['./icon-store-edit.component.scss'],
    standalone: false
})
export class IconStoreEditComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
